import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm text-catering-ink-900 shadow-catering-xs" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "tabular-nums" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "text-catering-ink-500"
}


export default {
  __name: 'BotDeliveryZone',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Delivery zone", -1)),
    (__props.block.has_polygon)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Delivers within a mapped zone on the map."))
      : _createCommentVNode("", true),
    ((__props.block.zip_codes || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-catering-ink-500" }, "ZIP codes:", -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString((__props.block.zip_codes || []).join(', ')), 1)
        ]))
      : _createCommentVNode("", true),
    ((__props.block.states || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-catering-ink-500" }, "States:", -1)),
          _createElementVNode("span", null, _toDisplayString((__props.block.states || []).join(', ')), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.block.has_polygon && !(__props.block.zip_codes || []).length && !(__props.block.states || []).length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " No delivery zone is configured yet. "))
      : _createCommentVNode("", true)
  ]))
}
}

}